import { R as h, q as u, _ as S, t as d, N as m, O, S as T } from "./export-cdcbfb2b.js";
import { i as $, b as E } from "./array-iteration-759bfbfa.js";
import { d as I } from "./es.array.concat-d1c9b847.js";
import { a as A, c as w } from "./create-property-f9780ed1.js";
var v = h, P = TypeError, b = function(a, s) {
  if (!delete a[s])
    throw new P("Cannot delete property " + v(s) + " of " + v(a));
}, _ = u, x = $, C = TypeError, L = Object.getOwnPropertyDescriptor, N = _ && !function() {
  if (this !== void 0)
    return !0;
  try {
    Object.defineProperty([], "length", { writable: !1 }).length = 1;
  } catch (a) {
    return a instanceof TypeError;
  }
}(), R = N ? function(a, s) {
  if (x(a) && !L(a, "length").writable)
    throw new C("Cannot set read only .length");
  return a.length = s;
} : function(a, s) {
  return a.length = s;
}, j = S, D = d, H = O, M = T, k = m, q = R, B = I, G = E, U = w, y = b, W = A, z = W("splice"), F = Math.max, J = Math.min;
j({ target: "Array", proto: !0, forced: !z }, {
  splice: function(s, g) {
    var e = D(this), n = k(e), f = H(s, n), c = arguments.length, o, t, l, r, i, p;
    for (c === 0 ? o = t = 0 : c === 1 ? (o = 0, t = n - f) : (o = c - 2, t = J(F(M(g), 0), n - f)), B(n + o - t), l = G(e, t), r = 0; r < t; r++)
      i = f + r, i in e && U(l, r, e[i]);
    if (l.length = t, o < t) {
      for (r = f; r < n - t; r++)
        i = r + t, p = r + o, i in e ? e[p] = e[i] : y(e, p);
      for (r = n; r > n - t + o; r--)
        y(e, r - 1);
    } else if (o > t)
      for (r = n - t; r > f; r--)
        i = r + t - 1, p = r + o - 1, i in e ? e[p] = e[i] : y(e, p);
    for (r = 0; r < o; r++)
      e[r + f] = arguments[r + 2];
    return q(e, n - t + o), l;
  }
});
export {
  b as d
};
